module.exports = __webpack_public_path__ + "img/api-explorer.d6b28445.svg";